import { FC, memo, useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex } from '@/components/atoms/Grid'
import { validFor } from '@/theme/validFor'
import { HeartIconDefault } from './icons/HeartIconDefault'
import { FilledHeartIconDefault } from './icons/FilledHeartIconDefault'

type HeartButtonProps = {
  isFilled: boolean
  height?: number
  width?: number
  onClick?: (e: Event) => void
} & Rest

const HeartButton: FC<HeartButtonProps> = memo(
  ({ isFilled: baseIsFilled, onClick, width, height, ...rest }) => {
    const [isFilled, setIsFilled] = useState<boolean>(false)
    const theme = useTheme()
    const iconProps = {
      height,
      width,
      isFilled
    }

    useEffect(() => {
      setIsFilled(baseIsFilled)
    }, [baseIsFilled])

    return (
      <Wrapper onClick={onClick} cursorOnHover={true} {...rest}>
        <StyledFilledHeart
          {...iconProps}
          color={theme.colors.accent}
          data-testid="heartButtonFilled"
        />
        <StyledEmptyHeart {...iconProps} />
      </Wrapper>
    )
  },
  (prev, next) => prev.isFilled === next.isFilled
)

export default HeartButton

const StyledFilledHeart = styled(FilledHeartIconDefault)`
  display: ${(props) => (props.isFilled ? 'block' : 'none')};
`

const StyledEmptyHeart = styled(HeartIconDefault)`
  display: ${(props) => (props.isFilled ? 'none' : 'block')};
`

const Wrapper = styled(Flex)`
  margin-right: 5px;
  ${validFor.desktop`
    &:hover {
      ${StyledFilledHeart} {
        opacity: 0.8;
        cursor: pointer;
        display: block;
      }
      ${StyledEmptyHeart} {
        display: none;
      }
    }
  `}
`
